import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { AuthenticationService } from "src/app/core/services/auth.service";
import { Categories } from "../../../core/models/categories.enum";

@Component({
  selector: "app-meal-and-food-voucher-accordion",
  templateUrl: "./meal-and-food-voucher-accordion.component.html",
  styleUrls: ["./meal-and-food-voucher-accordion.component.scss"],
})
export class MealandFoodVoucherAccordionComponent implements OnInit, OnChanges {
  @Input() benefits;
  planControl = new FormControl();
  isDisabled = true;
  selectedVaMonthly: any;

  constructor(private authService: AuthenticationService) {}
  employeeId;
  benefit: any;
  selectedPlan: any;

  ngOnInit(): void {
    this.employeeId = this.authService.currentUser().payload.employeeId;
    this.planControl.disable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getBenefits(changes?.benefits?.currentValue);
  }

  onOptionSelected(event: any) {
    this.removeSelectedPlan();

    if (!event) return;

    this.setVaMonthly(event.index);

    this.selectedPlan.selected = true;
    this.benefit.wantTheBenefit = true;
  }

  removeSelectedPlan() {
    this.benefit.items?.forEach((item) => (item.selected = false));
  }

  getBenefits(benefits?: any) {
    if (!benefits) return;
    const response = benefits;
    if (response.benefitTypes && response.benefitTypes.length > 0) {
      for (const type of response.benefitTypes) {
        const foundBenefit = type.benefitList.find(
          (benefit) => benefit.categoryId === Categories.VR_VA
        );
        if (foundBenefit) {
          this.benefit = foundBenefit;

          this.selectedPlan = this.benefit.items.find((item) => item.selected);
          if (this.selectedPlan) this.setVaMonthly(this.selectedPlan.index);
          break;
        }
      }
    }
  }

  private setVaMonthly(index: number) {
    this.selectedVaMonthly = this.benefit.vaMonthly.find(
      (x) => x.index == index
    );
  }
}
